/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {ÉµÉµinject} from '../../di/injector_compatibility';
import {ÉµÉµdefineInjectable, ÉµÉµdefineInjector} from '../../di/interface/defs';
import * as sanitization from '../../sanitization/sanitization';
import * as r3 from '../index';



/**
 * A mapping of the @angular/core API surface used in generated expressions to the actual symbols.
 *
 * This should be kept up to date with the public exports of @angular/core.
 */
export const angularCoreEnv: {[name: string]: Function} =
    (() => ({
       'ÉµÉµattribute': r3.ÉµÉµattribute,
       'ÉµÉµattributeInterpolate1': r3.ÉµÉµattributeInterpolate1,
       'ÉµÉµattributeInterpolate2': r3.ÉµÉµattributeInterpolate2,
       'ÉµÉµattributeInterpolate3': r3.ÉµÉµattributeInterpolate3,
       'ÉµÉµattributeInterpolate4': r3.ÉµÉµattributeInterpolate4,
       'ÉµÉµattributeInterpolate5': r3.ÉµÉµattributeInterpolate5,
       'ÉµÉµattributeInterpolate6': r3.ÉµÉµattributeInterpolate6,
       'ÉµÉµattributeInterpolate7': r3.ÉµÉµattributeInterpolate7,
       'ÉµÉµattributeInterpolate8': r3.ÉµÉµattributeInterpolate8,
       'ÉµÉµattributeInterpolateV': r3.ÉµÉµattributeInterpolateV,
       'ÉµÉµdefineBase': r3.ÉµÉµdefineBase,
       'ÉµÉµdefineComponent': r3.ÉµÉµdefineComponent,
       'ÉµÉµdefineDirective': r3.ÉµÉµdefineDirective,
       'ÉµÉµdefineInjectable': ÉµÉµdefineInjectable,
       'ÉµÉµdefineInjector': ÉµÉµdefineInjector,
       'ÉµÉµdefineNgModule': r3.ÉµÉµdefineNgModule,
       'ÉµÉµdefinePipe': r3.ÉµÉµdefinePipe,
       'ÉµÉµdirectiveInject': r3.ÉµÉµdirectiveInject,
       'ÉµÉµgetFactoryOf': r3.ÉµÉµgetFactoryOf,
       'ÉµÉµgetInheritedFactory': r3.ÉµÉµgetInheritedFactory,
       'ÉµÉµinject': ÉµÉµinject,
       'ÉµÉµinjectAttribute': r3.ÉµÉµinjectAttribute,
       'ÉµÉµtemplateRefExtractor': r3.ÉµÉµtemplateRefExtractor,
       'ÉµÉµNgOnChangesFeature': r3.ÉµÉµNgOnChangesFeature,
       'ÉµÉµProvidersFeature': r3.ÉµÉµProvidersFeature,
       'ÉµÉµInheritDefinitionFeature': r3.ÉµÉµInheritDefinitionFeature,
       'ÉµÉµcontainer': r3.ÉµÉµcontainer,
       'ÉµÉµnextContext': r3.ÉµÉµnextContext,
       'ÉµÉµcontainerRefreshStart': r3.ÉµÉµcontainerRefreshStart,
       'ÉµÉµcontainerRefreshEnd': r3.ÉµÉµcontainerRefreshEnd,
       'ÉµÉµnamespaceHTML': r3.ÉµÉµnamespaceHTML,
       'ÉµÉµnamespaceMathML': r3.ÉµÉµnamespaceMathML,
       'ÉµÉµnamespaceSVG': r3.ÉµÉµnamespaceSVG,
       'ÉµÉµenableBindings': r3.ÉµÉµenableBindings,
       'ÉµÉµdisableBindings': r3.ÉµÉµdisableBindings,
       'ÉµÉµallocHostVars': r3.ÉµÉµallocHostVars,
       'ÉµÉµelementStart': r3.ÉµÉµelementStart,
       'ÉµÉµelementEnd': r3.ÉµÉµelementEnd,
       'ÉµÉµelement': r3.ÉµÉµelement,
       'ÉµÉµelementContainerStart': r3.ÉµÉµelementContainerStart,
       'ÉµÉµelementContainerEnd': r3.ÉµÉµelementContainerEnd,
       'ÉµÉµpureFunction0': r3.ÉµÉµpureFunction0,
       'ÉµÉµpureFunction1': r3.ÉµÉµpureFunction1,
       'ÉµÉµpureFunction2': r3.ÉµÉµpureFunction2,
       'ÉµÉµpureFunction3': r3.ÉµÉµpureFunction3,
       'ÉµÉµpureFunction4': r3.ÉµÉµpureFunction4,
       'ÉµÉµpureFunction5': r3.ÉµÉµpureFunction5,
       'ÉµÉµpureFunction6': r3.ÉµÉµpureFunction6,
       'ÉµÉµpureFunction7': r3.ÉµÉµpureFunction7,
       'ÉµÉµpureFunction8': r3.ÉµÉµpureFunction8,
       'ÉµÉµpureFunctionV': r3.ÉµÉµpureFunctionV,
       'ÉµÉµgetCurrentView': r3.ÉµÉµgetCurrentView,
       'ÉµÉµrestoreView': r3.ÉµÉµrestoreView,
       'ÉµÉµinterpolation1': r3.ÉµÉµinterpolation1,
       'ÉµÉµinterpolation2': r3.ÉµÉµinterpolation2,
       'ÉµÉµinterpolation3': r3.ÉµÉµinterpolation3,
       'ÉµÉµinterpolation4': r3.ÉµÉµinterpolation4,
       'ÉµÉµinterpolation5': r3.ÉµÉµinterpolation5,
       'ÉµÉµinterpolation6': r3.ÉµÉµinterpolation6,
       'ÉµÉµinterpolation7': r3.ÉµÉµinterpolation7,
       'ÉµÉµinterpolation8': r3.ÉµÉµinterpolation8,
       'ÉµÉµinterpolationV': r3.ÉµÉµinterpolationV,
       'ÉµÉµlistener': r3.ÉµÉµlistener,
       'ÉµÉµload': r3.ÉµÉµload,
       'ÉµÉµprojection': r3.ÉµÉµprojection,
       'ÉµÉµupdateSyntheticHostBinding': r3.ÉµÉµupdateSyntheticHostBinding,
       'ÉµÉµcomponentHostSyntheticListener': r3.ÉµÉµcomponentHostSyntheticListener,
       'ÉµÉµpipeBind1': r3.ÉµÉµpipeBind1,
       'ÉµÉµpipeBind2': r3.ÉµÉµpipeBind2,
       'ÉµÉµpipeBind3': r3.ÉµÉµpipeBind3,
       'ÉµÉµpipeBind4': r3.ÉµÉµpipeBind4,
       'ÉµÉµpipeBindV': r3.ÉµÉµpipeBindV,
       'ÉµÉµprojectionDef': r3.ÉµÉµprojectionDef,
       'ÉµÉµproperty': r3.ÉµÉµproperty,
       'ÉµÉµpropertyInterpolate': r3.ÉµÉµpropertyInterpolate,
       'ÉµÉµpropertyInterpolate1': r3.ÉµÉµpropertyInterpolate1,
       'ÉµÉµpropertyInterpolate2': r3.ÉµÉµpropertyInterpolate2,
       'ÉµÉµpropertyInterpolate3': r3.ÉµÉµpropertyInterpolate3,
       'ÉµÉµpropertyInterpolate4': r3.ÉµÉµpropertyInterpolate4,
       'ÉµÉµpropertyInterpolate5': r3.ÉµÉµpropertyInterpolate5,
       'ÉµÉµpropertyInterpolate6': r3.ÉµÉµpropertyInterpolate6,
       'ÉµÉµpropertyInterpolate7': r3.ÉµÉµpropertyInterpolate7,
       'ÉµÉµpropertyInterpolate8': r3.ÉµÉµpropertyInterpolate8,
       'ÉµÉµpropertyInterpolateV': r3.ÉµÉµpropertyInterpolateV,
       'ÉµÉµpipe': r3.ÉµÉµpipe,
       'ÉµÉµqueryRefresh': r3.ÉµÉµqueryRefresh,
       'ÉµÉµviewQuery': r3.ÉµÉµviewQuery,
       'ÉµÉµstaticViewQuery': r3.ÉµÉµstaticViewQuery,
       'ÉµÉµstaticContentQuery': r3.ÉµÉµstaticContentQuery,
       'ÉµÉµloadViewQuery': r3.ÉµÉµloadViewQuery,
       'ÉµÉµcontentQuery': r3.ÉµÉµcontentQuery,
       'ÉµÉµloadContentQuery': r3.ÉµÉµloadContentQuery,
       'ÉµÉµreference': r3.ÉµÉµreference,
       'ÉµÉµelementHostAttrs': r3.ÉµÉµelementHostAttrs,
       'ÉµÉµclassMap': r3.ÉµÉµclassMap,
       'ÉµÉµstyling': r3.ÉµÉµstyling,
       'ÉµÉµstyleMap': r3.ÉµÉµstyleMap,
       'ÉµÉµstyleProp': r3.ÉµÉµstyleProp,
       'ÉµÉµstyleSanitizer': r3.ÉµÉµstyleSanitizer,
       'ÉµÉµstylingApply': r3.ÉµÉµstylingApply,
       'ÉµÉµclassProp': r3.ÉµÉµclassProp,
       'ÉµÉµselect': r3.ÉµÉµselect,
       'ÉµÉµtemplate': r3.ÉµÉµtemplate,
       'ÉµÉµtext': r3.ÉµÉµtext,
       'ÉµÉµtextBinding': r3.ÉµÉµtextBinding,
       'ÉµÉµtextInterpolate': r3.ÉµÉµtextInterpolate,
       'ÉµÉµtextInterpolate1': r3.ÉµÉµtextInterpolate1,
       'ÉµÉµtextInterpolate2': r3.ÉµÉµtextInterpolate2,
       'ÉµÉµtextInterpolate3': r3.ÉµÉµtextInterpolate3,
       'ÉµÉµtextInterpolate4': r3.ÉµÉµtextInterpolate4,
       'ÉµÉµtextInterpolate5': r3.ÉµÉµtextInterpolate5,
       'ÉµÉµtextInterpolate6': r3.ÉµÉµtextInterpolate6,
       'ÉµÉµtextInterpolate7': r3.ÉµÉµtextInterpolate7,
       'ÉµÉµtextInterpolate8': r3.ÉµÉµtextInterpolate8,
       'ÉµÉµtextInterpolateV': r3.ÉµÉµtextInterpolateV,
       'ÉµÉµembeddedViewStart': r3.ÉµÉµembeddedViewStart,
       'ÉµÉµembeddedViewEnd': r3.ÉµÉµembeddedViewEnd,
       'ÉµÉµi18n': r3.ÉµÉµi18n,
       'ÉµÉµi18nAttributes': r3.ÉµÉµi18nAttributes,
       'ÉµÉµi18nExp': r3.ÉµÉµi18nExp,
       'ÉµÉµi18nStart': r3.ÉµÉµi18nStart,
       'ÉµÉµi18nEnd': r3.ÉµÉµi18nEnd,
       'ÉµÉµi18nApply': r3.ÉµÉµi18nApply,
       'ÉµÉµi18nPostprocess': r3.ÉµÉµi18nPostprocess,
       'ÉµÉµi18nLocalize': r3.ÉµÉµi18nLocalize,
       'ÉµÉµresolveWindow': r3.ÉµÉµresolveWindow,
       'ÉµÉµresolveDocument': r3.ÉµÉµresolveDocument,
       'ÉµÉµresolveBody': r3.ÉµÉµresolveBody,
       'ÉµÉµsetComponentScope': r3.ÉµÉµsetComponentScope,
       'ÉµÉµsetNgModuleScope': r3.ÉµÉµsetNgModuleScope,

       'ÉµÉµsanitizeHtml': sanitization.ÉµÉµsanitizeHtml,
       'ÉµÉµsanitizeStyle': sanitization.ÉµÉµsanitizeStyle,
       'ÉµÉµdefaultStyleSanitizer': sanitization.ÉµÉµdefaultStyleSanitizer,
       'ÉµÉµsanitizeResourceUrl': sanitization.ÉµÉµsanitizeResourceUrl,
       'ÉµÉµsanitizeScript': sanitization.ÉµÉµsanitizeScript,
       'ÉµÉµsanitizeUrl': sanitization.ÉµÉµsanitizeUrl,
       'ÉµÉµsanitizeUrlOrResourceUrl': sanitization.ÉµÉµsanitizeUrlOrResourceUrl,
     }))();
